import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  trigger: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFF',
  },
  triggerError: {
    borderColor: '#900B09',
    borderWidth: 1.5,
  },
  triggerText: {
    fontSize: 14,
    color: '#1C1C1E',
    flex: 1,
    flexShrink: 1,
    marginRight: 8,
  },
  placeholder: {
    fontSize: 13,
    color: '#6B7280',
    flex: 1,
    flexShrink: 1,
    marginRight: 8,
  },
  listContainer: {
    position: 'absolute',
    top: 48,
    left: 0,
    right: 0,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    backgroundColor: '#FFF',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    zIndex: 9999,
    elevation: 20,
  },
  listItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  listItemText: {
    fontSize: 14,
    color: '#1C1C1E',
  },
  listItemTextSelected: {
    color: '#3F51B5',
    fontWeight: '700',
  },
  errorText: {
    fontSize: 12,
    color: '#900B09',
    marginTop: 4,
    fontWeight: '400',
  },
  iconDropdown: {
    fontSize: 20,
    color: '#6B7280',
    flexShrink: 0,
    marginLeft: 4,
  },
  iconDropdownList: {
    fontSize: 14,
    color: '#888',
  },
});
